export default {
  namespaced: true,
  state: {
    recent: {
      brands: [],
      total: 0,
    },
    alphabetical: {
      brands: [],
      total: 0,
    },
  },
  mutations: {
    updateRecentBrands(state, brands) {
      state.recent.brands = brands.data;
      state.recent.total = brands.total;
    },
    updateAlphabeticalBrands(state, brands) {
      state.alphabetical.brands = brands.data;
      state.alphabetical.total = brands.total;
    },
  },
};
